@if (fileType === 'image') {
<div>
  <!-- Image with controlled zoom and rotation -->
  @if (isImageLoading) {
  <div style="height: 40vh;
    position: absolute;
    top: 30%;
    left: 50%;">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="transparent"
      animationDuration=".5s" />
  </div>
  }
  @if (!isImageLoading) {
  <div>
    <div class="image-wrapper">
      @if (showViewer) {
      <app-image-viewer id="imgView" [src]="imageSrc" [(config)]="config" (customEvent)="handleEvent($event)"
        [(index)]="imageIndex" [fromTab]='fromTab' [fileName]="fileName"></app-image-viewer>
      }
    </div>
  </div>
  }
</div>
}
@if (fileType === 'pdf') {
<div>
  <!-- <div class="controls" *ngIf="!isPDFLoading">
      <p-button styleClass="file-button" (click)="downloadPdf()">Download PDF</p-button>
    </div> -->
  @if (isPDFLoading) {
  <div style="height: 55vh;
    position: absolute;
    top: 30%;
    left: 50%;">
    <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="transparent"
      animationDuration=".5s" />
  </div>
  }
  <!-- <iframe [hidden]="isPDFLoading" *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="100%"
    (load)="onPDFLoad()"></iframe> -->
  <app-pdf-viewer [fileUrl]="fileUrl" [fileName]="fileName"></app-pdf-viewer>
</div>
}